module.exports = __webpack_public_path__ + "img/logo2.021e1fdd.png";